import { createStyles, Theme } from '@material-ui/core'

export const searchFilterCardStyle = (theme: Theme) =>
  createStyles({
    card: {
      borderRadius: theme.spacing(1.5)
    },
    title: {
      fontWeight: 600,
      marginBottom: theme.spacing(1.5)
    },
    cardContent: {
      padding: theme.spacing(2),
      '&:last-child': {
        paddingBottom: theme.spacing(2)
      }
    },
    chipContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      flexWrap: 'wrap'
    },
    searchInput: {
      paddingBottom: theme.spacing(1)
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      gap: theme.spacing(1)
    },
    // look "estilo librería" para el TextField, aplicado solo acá vía classes
    // (InputProps/InputLabelProps/FormHelperTextProps) - no depende del theme global
    inputRoot: {
      // minHeight: '1.1876em',
      backgroundColor: theme.palette.background.paper,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.secondary.main
      },
      '&$inputFocused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$inputError $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$inputDisabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },
    notchedOutline: {
      borderColor: theme.palette.grey[400],
      '&$labelFocused': {
        color: theme.palette.primary.main
      }
    },
    inputFocused: {},
    inputError: {},
    inputDisabled: {},
    inputPadding: {
      padding: '18.5px 14px'
    },
    labelOutlined: {
      color: theme.palette.text.secondary,
      '&$labelFocused': {
        color: theme.palette.primary.main
      },
      '&$labelError': {
        color: theme.palette.error.main
      }
    },
    labelFocused: {},
    labelError: {},
    helperText: {
      marginLeft: 0
    }
  })
